module.exports = __webpack_public_path__ + "static/media/bronze-badge.78ab1a8e.png";